(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-native"));
	else if(typeof define === 'function' && define.amd)
		define("react-native-styleman", ["react", "react-native"], factory);
	else if(typeof exports === 'object')
		exports["react-native-styleman"] = factory(require("react"), require("react-native"));
	else
		root["react-native-styleman"] = factory(root["React"], root["react-native"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_native__) {
return 